import React from 'react';
import { observer } from 'mobx-react-lite';

export const LobbyIcon = observer(({ lobbyIconPostMessage, image }) => {
  return (
    <div className='lobby-container'>
      <button onClick={(e) => lobbyIconPostMessage(e)} className='lobby-btn'>
        <img alt='lobby' src={image} />
      </button>
    </div>
  );
});
